import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EcmMaterialModule } from '@ecm/material';

import { ErrorComponent } from './components/error/error.component';
import { SelectorContractComponent } from './components/selector/contract/selector-contract.component';
import { SelectorReboundLinksComponent } from './components/selector/shared/rebound-links/selector-rebound-links.component';
import { SelectorUsageComponent } from './components/selector/usage/selector-usage.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { routerTranslationFr } from './i18n/fr';
import { LinkPipe } from './pipes/link.pipe';

@NgModule({
    imports: [CommonModule, RouterModule, TranslateModule, EcmMaterialModule],
    declarations: [
        ErrorComponent,
        LinkPipe,
        SelectorContractComponent,
        SelectorReboundLinksComponent,
        SelectorUsageComponent,
        UnauthorizedComponent,
    ],
    providers: [],
    exports: [LinkPipe],
})
export class EcmRouterModule {
    private static translationLoaded = false;

    public constructor(translate: TranslateService) {
        if (!EcmRouterModule.translationLoaded) {
            translate.setTranslation('fr', routerTranslationFr, true);
            EcmRouterModule.translationLoaded = true;
        }
    }
}
